/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAgentGroup } from '../../models/api-response-paged-result-agent-group';
import { PagedRequestAgentGroup } from '../../models/paged-request-agent-group';

export interface SearchAgentGroup$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAgentGroup
}

export function searchAgentGroup(http: HttpClient, rootUrl: string, params: SearchAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAgentGroup>> {
  const rb = new RequestBuilder(rootUrl, searchAgentGroup.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAgentGroup>;
    })
  );
}

searchAgentGroup.PATH = '/v1/api/ui/agent-group/search';
